import { markerClick } from "./marker-events";

let bounds = new google.maps.LatLngBounds();

function createAllMarkers(map, mapMarkers) {
  const allMarkers = mapMarkers.map(marker => {
    bounds.extend(marker.location);
    const markerType = marker.type.toLowerCase();
    let icon;
    if (markerType === "akris boutique") {
      icon = mapIcons.marker2;
    } else {
      icon = mapIcons.marker1;
    }
    const markerObj = new google.maps.Marker({
      position: marker.location,
      icon: {
        url: icon,
        size: new google.maps.Size(16, 16)
      },
      customInfo: marker.target
    });
    markerClick(map, markerObj);
    return markerObj;
  });

  const markerCluster = new MarkerClusterer(map, allMarkers, {
    styles: [{
      url: mapIcons.mapCluster,
      width: 44,
      height: 44,
      textColor: "#ffffff",
      textSize: 15
    }]
  });

  map.fitBounds(bounds);
}

module.exports = {
  createAllMarkers
};



// WEBPACK FOOTER //
// ../assets/js/map/createAllMarkers.js